module.exports = __webpack_public_path__ + "static/back-lamp-e567df3b225e38a43b19b1aa3ecd97d2.jpg";